import { createLogger } from "@effektify/logger";
const LOG_LEVEL = "error";
let loggerInstance = null;
const getLogger = (scope, options = {}) => {
  if (loggerInstance) {
    return loggerInstance;
  }
  loggerInstance = createLogger(
    "Parser",
    scope,
    {
      level: LOG_LEVEL,
      ...options
    }
  ).logger;
  return loggerInstance;
};
export {
  getLogger as default
};
